import { render, staticRenderFns } from "./TransactionWeightModify.vue?vue&type=template&id=1865afa2&"
import script from "./TransactionWeightModify.vue?vue&type=script&lang=js&"
export * from "./TransactionWeightModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports